<template>
	<div>
		<!-- 菜单导航 -->
		<Menu></Menu>
		<div class="details_main">
			<div class="live-room">
				<div class="breadcrumb">
					<div class="breadcrumb-text">当前位置：<a href="/">首页</a><span>&gt;</span><a
							href="/#/personal">我的课程</a><span>&gt;</span>{{ courseData.name }}</div>
				</div>
				<section class="live-container">
					<div class="live-room">
						<div id="live-course" class="live-course">
							<div class="player-content">
								<div class="player-main">
									<div class="new-title">
										<div class="new-title-detail">{{ title }}</div>
										<div class="new-teacher">
											<div class="head-image-box teacher-head"><img
													:src="courseData.teacher.thumb"
													style="height: 32px; width: 32px; border-radius: 50%; margin-right:10px;"
													alt="唯远">
											</div><span>老师：{{ courseData.teacher.name }}</span>
										</div>
									</div>
									<div id="player" class="player show-title playerw100">
										<div @keyup="keyup($event)">
											<video-player class="video-player vjs-custom-skin" ref="videoPlayer"
												:playsinline="true" :options="playerOptions">
											</video-player>
										</div>
										<div class="right-aside"></div>
									</div>
								</div>
								<div class="chat-room">
									<ul class="tabs">
										<li :class="{'tab-item-active':(active == 1)}" @click="active = 1"
											class="tab-item"> 预习列表 </li>
										<li :class="{'tab-item-active':(active == 2)}" @click="active = 2"
											class="tab-item"> 知识扩展 </li>
									</ul>
									<div class="tabs-content">
										<ul class="chapter-list" v-if="active == 1">
											<li :class="{'video-active':(videoIndex == index)}"
												v-for="(item,index) in courseChapter" :key="index"
												@click="videoLook(index,item.video)" v-if="item.video"><span
													class="iconfont icon-shipin"></span>【第{{index+1}}节】{{ item.title }}
											</li>
										</ul>
										<ul class="chapter-list" v-else>
											<li :class="{'video-active':(videoIndex == index+100)}"
												v-for="(item,index) in courseData.course_chapter" :key="index"
												@click="videoLook(index+100,item.video)"><span
													class="iconfont icon-shipin"></span>【第{{index+1}}节】{{ item.title }}
											</li>
										</ul>
									</div>
								</div>
								<div class="submit-job_btn" v-if="isLive">
									<div><span class="submit-job_btn-bg">交作业</span></div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="commit-success" style="display: none;"></div>
					</div>
				</section>
			</div>
		</div>
		<!-- 底部链接 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import Menu from '@/components/view/Menu'
	import Footer from '@/components/view/Footer'
	export default {
		name: 'activity',
		components: {
			Menu,
			Footer
		},
		data() {
			return {
				videoIndex: -1,
				courseData: {},
				courseChapter: [],
				active: 1,
				playerOptions: {
					playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
					autoplay: false, // 如果为true,浏览器准备好时开始回放
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 是否视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4", // 类型
						src: '' // url地址
					}],
					poster: '', // 封面地址
					notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: false, // 是否显示剩余时间功能
						fullscreenToggle: true // 是否显示全屏按钮
					}
				},
				title: "",
				teacher: "",
				listobj: {},
				isLive: false
			}
		},
		created() {
			// 上级页面进入
			this.active = this.$route.query.tabIndex
			this.videoLook(this.$route.query.index, this.$route.query.video)
			this.chapterList()
		},
		methods: {
			keyup(key) {
				var vol = 0.1 //1代表100%音量，每次增减0.1
				var time = 10 //单位秒，每次增减10秒
				// 按向上键
				if (key.keyCode == 38) {
					this.$refs.videoPlayer.player.cache_.lastVolume !== 1 ?
						(this.$refs.videoPlayer.player.cache_.lastVolume += vol) :
						1
					this.$refs.videoPlayer.player.volume(
						this.$refs.videoPlayer.player.cache_.lastVolume
					)
				}
				// 按向下键
				if (key.keyCode == 40) {
					this.$refs.videoPlayer.player.cache_.lastVolume !== 0 ?
						(this.$refs.videoPlayer.player.cache_.lastVolume -= vol) :
						1
					this.$refs.videoPlayer.player.volume(
						this.$refs.videoPlayer.player.cache_.lastVolume
					)
				}
				// 按左键
				if (key.keyCode == 37) {
					this.$refs.videoPlayer.player.cache_.currentTime !== 0 ?
						(this.$refs.videoPlayer.player.cache_.currentTime -= time) :
						1
					this.$refs.videoPlayer.player.currentTime(
						this.$refs.videoPlayer.player.cache_.currentTime
					)
				}
				// 按右键
				if (key.keyCode == 39) {
					this.$refs.videoPlayer.player.cache_.currentTime !==
						this.$refs.videoPlayer.player.cache_.duration ?
						(this.$refs.videoPlayer.player.cache_.currentTime += time) :
						1
					this.$refs.videoPlayer.player.currentTime(
						this.$refs.videoPlayer.player.cache_.currentTime
					)
				}
			},
			chapterList() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/classDetail', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
					data: {
						"id": this.$route.query.id
					}
				}).then(res => {
					this.courseData = res.data.data
					this.courseChapter = res.data.data.chapter
				}).catch(err => {
					console.log(err)
				})
			},
			videoLook(index, video) {
				this.videoIndex = index;
				this.playerOptions = {
					playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
					autoplay: false, // 如果为true,浏览器准备好时开始回放
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 是否视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4", // 类型
						src: video // url地址
					}],
					poster: '', // 封面地址
					notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: false, // 是否显示剩余时间功能
						fullscreenToggle: true // 是否显示全屏按钮
					}
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	/deep/ .live-room .live-course .chat-room {
		height: 600px !important;
	}

	.tabs-content {
		height: 540px;
		overflow: auto;
	}

	.details_main {
		position: relative;
		background: #1F1F1F;
		padding-bottom: 50px;
		min-height: 750px;

		.liaotk {
			position: absolute;
			right: 0;
			top: 20px;
			width: 356px;
			height: 600px;
			background-color: #333;
			border-radius: 4px;
		}

		.botum_title {
			padding-bottom: 50px;
			color: #fff;
			width: 1000px;
			margin: 0 auto;

			.new-title-detail {
				text-align: right;
				padding-right: 50px;
			}
		}
	}
</style>
<style scoped>
	.video-active {
		color: #FAC211 !important;
	}

	.player-main {
		width: 960px;
	}

	.chapter-list {
		padding: 10px;
	}

	.chapter-list li {
		cursor: pointer;
		height: 62px;
		line-height: 62px;
		color: hsla(0, 0%, 100%, .6);
		font-size: 15px;
		font-weight: 500;
		position: relative;
		border-bottom: 1px solid hsla(0, 0%, 100%, .1);
		text-align: left;
		padding-left: 15px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.chapter-list li span {
		margin-right: 5px;
	}

	.live-room {
		background-color: #000;
		overflow: hidden;
	}

	.breadcrumb {
		margin-bottom: 40px;
		background: #282828;
		color: hsla(0, 0%, 100%, .6);
		font-size: 14px;
		height: 54px;
		line-height: 54px;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		text-align: left;
		padding-left: 20px;
	}

	.breadcrumb-text {
		width: 1350px;
		margin: 0 auto;
	}

	.breadcrumb-text a {
		color: hsla(0, 0%, 100%, .6);
	}

	.breadcrumb-text span {
		margin: 0 5px;
	}

	.live-room .live-course {
		width: 1350px;
		margin: 0 auto;
	}

	.live-room .live-course .player-content {
		width: 100%;
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}

	.new-title-player-full,
	.new-title {
		position: absolute;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		color: #fff;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: start;
		-ms-flex-pack: start;
		justify-content: flex-start;
		padding: 0 20px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		top: 0;
		left: 0;
		height: 60px;
		background: #333;
		border-radius: 4px 4px 0 0;
	}

	.new-title {
		width: 960px;
	}

	.new-teacher {
		margin-left: auto;
		font-size: 16px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		justify-content: space-between;
	}

	.live-room .live-course .chat-room {
		position: relative;
		margin-left: 20px;
		float: left;
		width: 356px;
		height: 600px;
		background-color: #333;
		border-radius: 4px;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-content {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-left: 8px solid #333;
		border-right: 8px solid #333;
		border-bottom: 8px solid #333;
		height: 424px;
		overflow-y: auto;
		padding: 0 15px 10px 15px;
		color: #fff;
		border-radius: 4px;
	}

	.chat-item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 100%;
	}



	.playerw100 {
		width: 100% !important;
	}

	.chat-item>div {
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
	}

	.chat-content>div {
		overflow: hidden;
		padding-top: 12px;
	}

	.chat-item img {
		cursor: default;
		width: 40px;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.user-avatar {
		border-radius: 50%;
		margin-right: 10px;
		margin-top: -12px;
		width: 40px;
		height: 40px;
	}

	.user-info {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}

	.user-info .user-name {
		font-size: 12px;
		color: #fff;
		cursor: pointer;
		word-break: break-word;
	}

	.user-info .content-time {
		line-height: 17px;
		margin-left: 4px;
		font-size: 12px;
		color: hsla(0, 0%, 100%, .6);
		cursor: pointer;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment>textarea {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		height: 50px;
		width: 100%;
		color: #888;
		border: none;
		padding: 10px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #fff;
		background: #2d2d2d;
		outline: none;
		resize: none;
		caret-color: #00d752;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .chat-btn-group {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		height: 46px;
		color: #989898;
		font-size: 14px;
		margin-top: 7px;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .emoji-btn {
		margin-left: 10px;
		margin-right: 40px;
		display: inline-block;
		width: 20px;
		height: 20px;
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAbdJREFUOE+1lTFIHGEQhb8nBkHQVIEUgmAgkNJCCAhHAhZ2WhySXJEuKUROFBS7IFiEC0QUsdDOQkUuoJ2dEggErrAMBBQCKQQrFQ5CQkYmzB3ruuIp58IW+/9z3+x7/9s5kXGZWSvwIu5nwKMoOwG+A/t+S/qb/rnSC2b2EhgHurKaJdZ+AQuS9pJ1daCZtQBjwJsoOAR2gG/Acaw9Bp4DQ8CTWFsDliT98+cksBiwP8A8UK4VZajw5nlgAngArElarAND5kfAYUVJlRvk/t82sz7AQQ6dcvmKAyiHZyVJW43AajVmNgJMA+5p3oEDwAfAPXvtMs1sFHgFbEpaTjZI74X3G+HpjAPngEHgk6T1kPIFaAeqknIp4JU9MysAk8CuAz8D3cCIpKMANvyGUd8DuFU/HVjrmJNUvY1/CR9djXOq9wLMktwJuJ8VSbMpD98DHpeCpLMsyVmH8hDYBjo84MBqQN9GoM+BYUmnAbx0KFdiE0X9QAloS/n623Mn6WvU+VdzKTY+WTKDbWZPgXdAb0APgBVJP64NdnTxCdOcTy/RqXnDIeFF88ZX4k2bM2BTWbvzX8AFbZ/8bebny04AAAAASUVORK5CYII=);
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .feed-back {
		visibility: hidden;
		margin-right: 5px;
		display: inline-block;
		width: 20px;
		height: 20px;
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAA4UlEQVQ4je3VP0oDQRQH4C9DwCaElGIfvEFY7CIhBxDPsOQIQhqDEOw9QC4QPIAIaT1CwF7bkFjZxCIbHBYx7h+7/JoZHsPHm+HBNNI0hS7uMUBbuazxjBu8NnGOF3RKgvu0cYVLJAHTGtA4HUyD3fXrzjAo/6a/pRUOHPjECJOicgxPcsA7+pjhtCjcjPbbCB7iOqstcJHVG38wt3n4Nlrv0MMcZ0W7zcMx/oYHnPzUTRk4xivlOBV75zgV3zk0FZXg9T+4H8HuO6k7TwFjrGpEVxgHLJHgEZsK4CYzEiy/AMbnNFV+pUyxAAAAAElFTkSuQmCC);
		background-size: 100% 100%;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .chat-btn-group>span {
		cursor: pointer;
	}

	.text-length-disable {
		color: #ff4747;
	}

	.text-length-disable,
	.text-length {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		margin-left: auto;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .chat-btn-group>span {
		cursor: pointer;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .chat-btn-group>span {
		cursor: pointer;
	}

	.live-room .live-course .chat-room .tabs-content .course-chat .chat-comment .send-comment-disable {
		width: 60px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		margin-right: 12px;
		background: #666;
		border-radius: 4px;
		color: hsla(0, 0%, 100%, .8);
	}

	.decorate-line {
		color: #fff;
		opacity: .1;
		width: 1px;
		padding: 0 12px;
	}

	.content-other,
	.content-user {
		display: inline-block;
		margin-top: 3px;
		position: relative;
		min-height: 10px;
		word-break: break-all;
		white-space: pre-wrap;
		word-wrap: break-word;
		background: #fff;
		padding: 8px;
		font-size: 14px;
		border-radius: 2px 6px 6px 6px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		max-width: 244px;
	}



	#player .player-control-bottom-custom {
		opacity: 0;
		display: none;
	}

	.content-other,
	.content-user {
		display: inline-block;
		margin-top: 3px;
		position: relative;
		min-height: 10px;
		word-break: break-all;
		white-space: pre-wrap;
		word-wrap: break-word;
		background: #fff;
		padding: 8px;
		font-size: 14px;
		border-radius: 2px 6px 6px 6px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		max-width: 244px;
	}

	.user-info {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}


	.live-room .live-course .chat-room .tabs-content .course-chat .chat-content {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-left: 8px solid #333;
		border-right: 8px solid #333;
		border-bottom: 8px solid #333;
		height: 424px;
		overflow-y: auto;
		padding: 0 15px 10px 15px;
		color: #fff;
		border-radius: 4px;
	}

	.player-control-bottom-custom {
		position: absolute;
		bottom: 0;
		left: 0;
		height: 64px;
		background-color: rgba(0, 0, 0, .5);
		width: 100%;
		z-index: 6;
	}

	.pv-ppt-layout {
		position: relative;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background-color: #f6f9fa;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		background-repeat: no-repeat;
		background-position: center center;
		background-size: auto 100%;
	}

	#playerRtc {
		position: absolute;
		visibility: hidden;
	}

	.live-room .live-course .player {
		float: left;
		min-width: 960px;
	}

	.show-title {
		margin-top: 60px;
	}

	#student {
		position: absolute;
		z-index: -1;
		visibility: hidden;
	}

	.live-room .live-course .chat-room {
		position: relative;
		margin-left: 20px;
		float: left;
		width: 406px;
		height: 600px;
		background-color: #333;
		border-radius: 4px;
	}

	.live-room .live-course .chat-room .tabs {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		padding: 8px 35px 0 30px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		height: 60px;
	}

	.submit-job_btn {
		position: absolute;
		right: -60px;
		bottom: 0;
		outline: none;
		border: none;
		background-size: 64px;
		width: 64px;
		height: 64px;
		background-position: 50%;
		background-size: contain;
		border-radius: 50%;
		background-color: transparent;
		background-repeat: no-repeat;
		cursor: pointer;
	}

	.content-other>div,
	.content-user>div {
		float: left;
		text-align: left;
		color: #585958;
		max-width: 228px;
		min-width: 5px;
		word-break: break-all;
		white-space: pre-wrap;
		word-wrap: break-word;
	}

	.chat-content-body {
		text-align: left;
	}

	.live-room .live-course .chat-room .tabs {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		padding: 8px 35px 0 30px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		height: 60px;
	}

	.live-room .live-course .chat-room .tabs .tab-item-active {
		color: #fff;
		position: relative;
	}

	.live-room .live-course .chat-room .tabs .tab-item {
		padding: 10px 0 5px;
		font-size: 18px;
		cursor: pointer;
		position: relative;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: hsla(0, 0%, 100%, .8);
		-webkit-transition: color .1s ease;
		transition: color .1s ease;
	}

	.live-room .live-course .chat-room .tabs .tab-item {
		padding: 10px 0 5px;
		font-size: 18px;
		cursor: pointer;
		position: relative;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: hsla(0, 0%, 100%, .8);
		-webkit-transition: color .1s ease;
		transition: color .1s ease;
	}

	.live-room .live-course .chat-room .tabs .tab-item-active:after {
		content: "";
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		height: 3px;
		background-color: #00d753;
		width: 100%;
	}

	.live-room .live-course .chat-room .tabs .tab-item .online-num {
		position: absolute;
		left: 75px;
		top: 49%;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		font-size: 12px;
		color: #00d753;
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// src/components/CurriculumDetails.vue